













































































import Vue from 'vue'
import { TenantAppServiceProxy, TenantAppVO, AppServiceProxy, IPageOfApp, App  } from '@/service-proxies/app-v2/system.service-proxies'
const asp = new AppServiceProxy()
const sp = new TenantAppServiceProxy()
export default Vue.extend({
  props: {
    tenant: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      queryParam: {
        current: 1,
        keywords: '',
        size: 99
      },
      orininalList: [],
      appList: [],
      loading: false,
      now: Date.now()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    save() {
      this.form.validateFields(async (err: any, vals: any) => {
        if (!err) {
          const app = this.orininalList.find((item) => item.code === vals.appCode)
          if (!app) return
          const body: any = {
            tenantId: this.tenant.tenantId,
            appCode: vals.appCode,
            sort: vals.sort,
            expireTime: vals.expireTime.format('YYYY-MM-DD HH:mm:ss'),
            appAvatar: app.avatar,
            appDisplayName: app.displayName
          }
          this.loading = true
          try {
            await sp.grantAppForTenant(body)
            this.$message.success('授权成功')
            this.$emit('close')
          } catch (e) {}
          this.loading = false
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
    async loadData() {
      const { current, keywords, size } = this.queryParam
      // const t = this.tenant
      const res: IPageOfApp = await asp.page(this.tenant.classes, void 0, current, void 0, size)
      if (!res.records) return
      this.orininalList = res.records
      this.appList = (res.records || []).map((item) => {
        return {
          label: `${item.code}-${item.displayName}` || '',
          value: item.code || ''
        }
      })
    },
    timeValidator(rule: any, value: any, cb: Function) {
      if (value) {
        if (value.valueOf() < this.now) {
          cb('不应授权过去时间')
        }
      }
      cb()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
})
